import React from "react";

function SvgIcMapPoi097(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M12.03 11c1.087 0 1.968.895 1.968 2v1.99L14 15v3c0 .552-.441 1-.984 1-.045 0-.084-.02-.127-.026V19h-.921v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6h-.984A.993.993 0 016 18v-5c0-1.105.881-2 1.968-2zm8.563 0h2.904c.587 0 1.046.347 1.317.854l.064.13 1.98 4.615.005.015.006.014.023.057c.028.1.049.204.049.315a.993.993 0 01-.984 1 .979.979 0 01-.895-.596l-.04-.108-.01.003-1.113-2.716c-.1-.256-.365-.38-.598-.274-.214.096-.37.256-.29.564l.036.109v.002l-.001.004 1.888 5.732c.02.089.039.182.039.28 0 .513-.38.936-.87.994l-.114.007-.003-.001h-.981v3c0 .513-.38.935-.87.993l-.114.007h-1.1a.989.989 0 01-.978-.884L19.937 25v-3h-.981a.991.991 0 01-.966-1.19l.022-.09h-.004l1.9-5.734.003-.004a.516.516 0 00-.28-.668.5.5 0 00-.608.191l-.042.08-1.053 2.714a1.002 1.002 0 01-.944.702.993.993 0 01-.958-1.215l.029-.1-.005-.001.022-.057.006-.014.006-.015 1.979-4.614c.275-.573.746-.984 1.382-.984l1.13-.001h2.758zM9.969 6c1.086 0 1.968.894 1.968 1.998 0 1.105-.882 2.002-1.968 2.002C8.883 10 8 9.103 8 7.998 8 6.894 8.883 6 9.969 6zm11.5 0c1.086 0 1.967.895 1.967 1.998 0 1.106-.88 2.002-1.968 2.002-1.086 0-1.968-.896-1.968-2.002C19.5 6.895 20.382 6 21.468 6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi097;
